import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

const Circle = styled.span<{ $size: number; $thickness: number }>`
    display: inline-block;
    inline-size: ${({ $size }) => `${$size}px`};
    block-size: ${({ $size }) => `${$size}px`};
    border: ${({ $thickness }) => `${$thickness}px`} solid currentColor;
    border-top-color: transparent;
    border-radius: 50%;
    animation: ${spin} 0.9s linear infinite;
    flex-shrink: 0;
`;

interface SpinnerProps {
    size?: number;
    thickness?: number;
    className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
    size = 16,
    thickness = 2,
    className,
}) => (
    <Circle
        $size={size}
        $thickness={thickness}
        className={className}
        role='status'
        aria-label='Loading'
    />
);

export default Spinner;
